import { Divider } from '@/components';
import { DataGridRef } from '@/components/dataGrid/dataGrid';
import Header from '@/core/components/header/header';
import CompaniesService from '@/modules/company/services/companiesService';
import { DialogRelease } from '@/modules/copay/components/dialogRelease/dialogRelease';
import { DialogShareCopay } from '@/modules/copay/components/dialogShareCopay/dialogShareCopay';
import { UsageStatementList } from '@/modules/copay/components/usageStatementList/usageStatementList';
import {
  UsageStatement,
  UsageStatementProcess,
} from '@/modules/copay/entities/interfaces/usageStatements';
import { CopayService } from '@/modules/copay/services/copayService';
import useCompany from '@/shared/hooks/useCompany/useCompany';
import { useRequestCreation } from '@/shared/hooks/useRequestData/useRequestCreation';
import { useRequestPaginatedList } from '@/shared/hooks/useRequestData/useRequestPaginatedList';
import ICONS from '@/shared/entities/constants/icons';
import React, { useMemo, useRef, useState } from 'react';
import { Button, Text } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';

export const List: React.FC = () => {
  const [openDialogRelease, setOpenDialogRelease] = useState(false);
  const [openDialogShareCopay, setOpenDialogShareCopay] = useState(false);
  const [
    usageStatementWithWaitingDescriptionStatus,
    setUsageStatementWithWaitingDescriptionStatus,
  ] = useState<UsageStatementProcess | null>(null);

  const { company } = useCompany();
  const { data: companyParents } = useRequestPaginatedList({
    autoLoad: Boolean(company.salesforceParentId),
    source: () =>
      new CompaniesService().getCompanies({
        salesforceId: company.salesforceParentId || undefined,
      }),
  });
  const listRef = useRef<DataGridRef | undefined>(undefined);

  const companyParentId = useMemo(() => {
    return company.salesforceParentId ? companyParents?.pop()?.id : company.id;
  }, [company.id, company.salesforceParentId, companyParents]);

  const { requestCreate: releaseCopay } = useRequestCreation<UsageStatement>({
    request: (usageStatement) => new CopayService().release(usageStatement.id),
  });

  return (
    <>
      <DialogRelease
        open={openDialogRelease}
        setOpen={setOpenDialogRelease}
        companyParentId={companyParentId}
        company={company}
        callbackDownload={async (usageStatement) => {
          await releaseCopay(usageStatement);
          listRef.current?.refreshData();
        }}
      />

      <DialogShareCopay
        open={openDialogShareCopay}
        setOpen={setOpenDialogShareCopay}
        usageStatementId={usageStatementWithWaitingDescriptionStatus?.id}
      />

      <Grid column stretch gap={24}>
        <Header title='Isenção de coparticipação' iconSrc={ICONS.MONEY_SIGN}>
          <Button
            label='Baixar arquivo de isenção'
            iconColor='light'
            icon={ICONS.DOWNLOAD}
            onClick={() => setOpenDialogRelease(true)}
          />
        </Header>

        <Divider space={0} />

        <Text color='colorDefault' value='Status das coparticipações' title />

        <UsageStatementList
          instanceEmitter={listRef}
          company={company}
          companyParentId={companyParents?.pop()?.id}
          setOpenDialogShareCopay={setOpenDialogShareCopay}
          setUsageStatementWithWaitingDescriptionStatus={
            setUsageStatementWithWaitingDescriptionStatus
          }
        />
      </Grid>
    </>
  );
};
